<template>
  <ValidationProvider
    v-show="show"
    v-slot="{ errors }"
    :vid="randomName"
    class="form-group"
    :name="label"
    :disabled="disabled"
    :rules="rules"
    tag="div"
    mode="eager"
  >
    <label v-if="label">{{ label }}</label>
    <quill-editor
      v-if="!readonly"
      v-model="field"
      dir="rtl"
      :type="type"
      :placeholder="placeholder"
      :disabled="isDisabled"
      :readonly="readonly"
      v-on="{
        ...$listeners,
        input: (e) => e.html,
      }"
    ></quill-editor>
    <div
      v-else
      class="mb-3 p-1"
      style="word-break: break-all"
      v-html="field"
    ></div>
    <small class="text-danger">{{ errors[0] }}</small>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import fieldMixins from "@/mixins/fieldMixins";

export default {
  name: "VTextEditor",
  components: {
    ValidationProvider,
  },
  mixins: [fieldMixins],
  props: {
    type: {
      type: String,
      default: "text",
    },
  },
  computed: {
    isDisabled() {
      if (typeof this.disabled === "function") return this.disabled();
      return this.disabled;
    },
    field: {
      get() {
        return this.value;
      },
      set(value) {
        // eslint-disable-next-line no-console
        this.$emit("input", value);
      },
    },
    randomName() {
      return Math.random().toString(36).substring(7);
    },
  },
  watch: {
    value() {
      this.field = this.value;
    },
  },
};
</script>

<style scoped></style>
